import React from 'react';
import NextGenImage from './NextGenImage';

// Default fallback SVG as a base64 data URL
const DEFAULT_COIN_SVG = `data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgZmlsbD0iIzE0RjE5NSIgc3Ryb2tlPSIjMDgwODEwIi8+PHBhdGggZD0iTTEyIDZWMTIiIHN0cm9rZT0iIzA4MDgxMCIvPjxwYXRoIGQ9Ik0xNiAxMkgxMiIgc3Ryb2tlPSIjMDgwODEwIi8+PC9zdmc+`;

// Path constants for different image types
const COIN_IMAGE_PATHS = {
  BASE: '/images/coins/'
};

// SOL specific defaults
const SOL_FALLBACK_SVG = '/images/custom-solana-logo.svg';

interface CoinIconProps {
  symbol: string;
  size?: number;
  className?: string;
  preferredFormat?: 'svg' | 'webp' | 'avif' | 'png';
}

/**
 * Component for displaying coin icons with fallback support
 */
const CoinIcon: React.FC<CoinIconProps> = ({
  symbol,
  size = 32,
  className = '',
  preferredFormat = 'svg'
}) => {
  // Defensive: Ensure symbol is a non-empty string
  const normalizedSymbol = typeof symbol === 'string' && symbol.trim() ? symbol.toUpperCase() : 'UNKNOWN';
  const basePath = normalizedSymbol !== 'UNKNOWN' ? `${COIN_IMAGE_PATHS.BASE}${normalizedSymbol}` : '/images/coins/placeholder-coin';
  const fallbackSrc = normalizedSymbol === 'SOL' ? SOL_FALLBACK_SVG : DEFAULT_COIN_SVG;
  
  return (
    <div 
      className={`coin-icon ${className}`} 
      style={{ width: size, height: size }}
    >
      <NextGenImage
        srcBase={basePath}
        alt={`${normalizedSymbol} icon`}
        width={size}
        height={size}
        className="w-full h-full object-cover"
        svg={preferredFormat === 'svg'}
        loading="lazy"
        onError={e => { (e.target as HTMLImageElement).src = fallbackSrc; }}
      />
    </div>
  );
};

export default CoinIcon; 